<template>
    <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4">
        <!-- Virtual Clinic (Levo) -->
        <div class="flex flex-col gap-4 col-span-1">
            <NuxtLink
                class="relative rounded-lg flex-1 bg-violet-900 shadow-md text-white p-4 flex flex-col justify-between"
                :to="$localeRoute('/patients/virtual-clinic')"
            >
                <div class="flex flex-col items-start gap-4">
                    <div class="flex items-center gap-6">
                        <div class="logo-container">
                            <div class="logo"></div>
                        </div>
                        <h1 class="text-6xl font-extrabold">
                            {{ $t("navigation.virtualClinic").toLowerCase() }}
                        </h1>
                    </div>

                    <div class="mt-4">
                        <p class="text-2xl">
                            {{ $t("patients.subtitle") }}
                        </p>
                    </div>
                </div>
                <div class="flex items-center gap-4 w-full mt-auto">
                    <h1 class="text-4xl font-extrabold flex-1">
                        {{
                            $t(
                                "patients.virtualClinic.bookYourApointmentToday",
                            ).toUpperCase()
                        }}
                    </h1>

                    <svg
                        class="self-center"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 100 100"
                        width="100"
                        height="100"
                    >
                        <path
                            d="M20,50 L80,50 M50,20 L80,50 L50,80"
                            fill="none"
                            stroke="white"
                            stroke-width="5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </div>
            </NuxtLink>
            <NuxtLink
                class="relative rounded-lg flex-1 bg-violet-900 shadow-md text-white p-4 flex flex-col justify-between"
                :to="$localeRoute('scientists')"
            >
                <div class="flex items-center gap-4 w-full mt-auto">
                    <h1 class="text-4xl font-extrabold flex-1">
                        {{
                            $t(
                                "patients.virtualClinic.newsInOurServices",
                            ).toUpperCase()
                        }}
                    </h1>

                    <svg
                        class="self-center"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 100 100"
                        width="100"
                        height="100"
                    >
                        <path
                            d="M20,50 L80,50 M50,20 L80,50 L50,80"
                            fill="none"
                            stroke="white"
                            stroke-width="5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </div>
            </NuxtLink>
        </div>

        <!-- Ostale kartice (2x2 grid desno) -->
        <div
            class="grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 gap-4 col-span-2"
        >
            <div class="flex flex-col gap-4">
                <!-- Card 2 -->
                <NuxtLink
                    class="relative rounded-lg flex-1 bg-transparent p-4"
                    :to="$localeRoute('/patients/prevention')"
                >
                    <h1 class="text-4xl text-violet-900">
                        {{ $t("navigation.prevention") }}
                    </h1>
                    <h1 class="text-4xl text-violet-900">
                        & {{ $t("navigation.longevity") }}
                    </h1>
                    <p class="w-4/5">
                        {{ $t("patients.preventionAndLongevity.subtitle") }}
                    </p>
                    <svg
                        class="absolute bottom-0 right-0"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 100 100"
                        stroke-width="5"
                        stroke="#4c1d95"
                        width="100"
                        height="100"
                    >
                        <path
                            d="M30,30 L70,70 M70,30 L70,70 L30,70"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </NuxtLink>
            </div>
            <div class="flex flex-col gap-4">
                <!-- Card 3 -->
                <NuxtLink
                    class="relative rounded-lg flex-1 bg-transparent p-4"
                    :to="$localeRoute('/patients/treatment')"
                >
                    <h1 class="text-4xl text-violet-900">
                        {{ $t("navigation.treatment") }}
                    </h1>
                    <div
                        class="w-4/5 mt-10"
                        :key="$t('patients.treatment.subtitle')"
                        v-html="$t('patients.treatment.subtitle')"
                    ></div>
                    <svg
                        class="absolute bottom-0 right-0"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 100 100"
                        stroke-width="5"
                        stroke="#4c1d95"
                        width="100"
                        height="100"
                    >
                        <path
                            d="M30,30 L70,70 M70,30 L70,70 L30,70"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </NuxtLink>
            </div>
            <div class="flex flex-col gap-4">
                <!-- Card 4 -->
                <NuxtLink
                    class="relative rounded-lg flex-1 bg-transparent p-4"
                    :to="$localeRoute('/patients/womans-health')"
                >
                    <h1 class="text-4xl text-violet-900">
                        {{ $t("navigation.womansHealth") }}
                    </h1>
                    <p class="w-4/5">
                        {{ $t("patients.womansHealth.subtitle") }}
                    </p>
                    <svg
                        class="absolute bottom-0 right-0"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 100 100"
                        stroke-width="5"
                        stroke="#4c1d95"
                        width="100"
                        height="100"
                    >
                        <path
                            d="M30,30 L70,70 M70,30 L70,70 L30,70"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </NuxtLink>
            </div>
            <div class="flex flex-col gap-4">
                <!-- Card 3 -->
                <NuxtLink
                    class="relative rounded-lg flex-1 bg-transparent p-4"
                    :to="$localeRoute('/patients/holiday')"
                >
                    <h1 class="text-4xl text-violet-900">
                        {{ $t("patients.womansHealth.holidayPackageTitle") }}
                    </h1>
                    <div
                        class="w-4/5"
                        :key="
                            $t('patients.womansHealth.holidayPackageSubtitle')
                        "
                        v-html="
                            $t('patients.womansHealth.holidayPackageSubtitle')
                        "
                    ></div>
                    <svg
                        class="absolute bottom-0 right-0"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 100 100"
                        stroke-width="5"
                        stroke="#4c1d95"
                        width="100"
                        height="100"
                    >
                        <path
                            d="M30,30 L70,70 M70,30 L70,70 L30,70"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </NuxtLink>
            </div>
            <div class="flex flex-col gap-4">
                <!-- Card 5 -->
                <NuxtLink
                    class="relative rounded-lg flex-1 bg-transparent p-4"
                    :to="$localeRoute('/patients/prescription')"
                >
                    <h1 class="text-4xl text-violet-900">
                        {{ $t("navigation.prescriptionService") }}
                    </h1>
                    <p class="w-4/5">
                        {{ $t("patients.prescription.subtitle") }}
                    </p>
                    <svg
                        class="absolute bottom-0 right-0"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 100 100"
                        stroke-width="5"
                        stroke="#4c1d95"
                        width="100"
                        height="100"
                    >
                        <path
                            d="M30,30 L70,70 M70,30 L70,70 L30,70"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </NuxtLink>
            </div>
            <div class="flex flex-col gap-4">
                <!-- Card 6 -->
                <NuxtLink
                    class="relative rounded-lg flex-1 bg-transparent p-4"
                    :to="$localeRoute('/patients/virtual-clinic')"
                >
                    <h1 class="text-4xl text-violet-900">
                        {{
                            $t(
                                "patients.virtualClinic.howItWorks.ongoingSupport.title",
                            )
                        }}
                    </h1>
                    <p class="w-4/5">
                        {{
                            $t(
                                "patients.virtualClinic.howItWorks.ongoingSupport.content",
                            )
                        }}
                    </p>
                    <svg
                        class="absolute bottom-0 right-0"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 100 100"
                        stroke-width="5"
                        stroke="#4c1d95"
                        width="100"
                        height="100"
                    >
                        <path
                            d="M30,30 L70,70 M70,30 L70,70 L30,70"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </NuxtLink>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { useHead } from "#imports";
import { useLanguagesStore } from "~/stores/languages";

const languageStore = useLanguagesStore();

useHead({
    title: "Patients - Cardioteam",
    meta: [
        {
            name: "description",
            content:
                "Discover the best health care for you at our online clinic! Browse our extensive range of medical services, including diagnosis and treatment for various conditions. Take advantage of virtual consultations, telemedicine appointments, and easy booking options. Experience personalized healthcare on demand and boost your well-being today.",
        },
        {
            name: "keywords",
            content:
                "Cardioteam, patients, virtual clinic, prevention, longevity, treatment",
        },
        {
            name: "og:description",
            content:
                "Discover the best health care for you at our online clinic! Browse our extensive range of medical services, including diagnosis and treatment for various conditions. Take advantage of virtual consultations, telemedicine appointments, and easy booking options. Experience personalized healthcare on demand and boost your well-being today.",
        },
    ],
});
</script>

<style scoped>
.logo-container {
    width: 150px;
    height: 150px;
    perspective: 800px; /* Adds depth to the 3D effect */
}

.logo {
    width: 100%;
    height: 100%;
    background: url("/images/monitor.png") no-repeat center/contain;
    animation: rotateLogo 3s infinite linear;
    transform-origin: center;
    transform-style: preserve-3d;
}

@keyframes rotateLogo {
    from {
        transform: rotateY(0deg);
    }
    to {
        transform: rotateY(360deg);
    }
}
</style>
